{
  "Dashboard": "ダッシュボード",
  "BlyCareShippingProte": "BlyCare 配送保証",
  "LoadingBlyCare": "BlyCare を読み込み中…",
  "LoadingWidgetSetting": "ウィジェット設定を読み込み中…",
  "PreparingYourWorkspa": "ワークスペースを準備しています",
  "Language": "言語",
  "English": "English",
  "EnglishDefault": "English（デフォルト）",
  "German": "Deutsch",
  "Spanish": "Español",
  "French": "Français",
  "Italian": "Italiano",
  "Japanese": "日本語",
  "Korean": "한국어",
  "Dutch": "Nederlands",
  "Polish": "Polski",
  "Portuguese": "Português",
  "Ukrainian": "Українська",
  "SimplifiedChinese": "简体中文",
  "TraditionalChinese": "繁體中文",
  "SetupGuide": "設定ガイド",
  "CompletedOfTotalComp": "{{total}} 件中 {{completed}} 件完了",
  "Dismiss": "閉じる",
  "MoreActions": "その他の操作",
  "ToggleSetupGuide": "設定ガイドを切り替え",
  "ActivateAppEmbed": "アプリ埋め込みを有効にする",
  "ClickTheEnableButton": "1. 下の「有効にする」ボタンをクリックして、Shopify テーマエディターを開きます。",
  "BlyCareEmbedSection": "2. 左側の「アプリ埋め込み」セクションで BlyCare を探します。トグルがオンになっていることを確認し、右上の「保存」をクリックします。",
  "Enable": "有効にする",
  "PublishWidget": "ウィジェットを公開",
  "PublishStorefront": "ストアフロントでウィジェットを公開し、顧客が購入できるようにします。",
  "Publish": "公開",
  "SetProtectionFee": "保護料金を設定",
  "FeeYouWantToCharge": "顧客に請求する料金を設定します。",
  "Setup": "設定",
  "TestYourWidgetOnYour": "ストアでウィジェットをテスト",
  "AddAProductToYourCar": "商品をカートに追加し、配送保証ウィジェットが表示されることを確認します。配送保証を選択してチェックアウトに進み、チェックアウトページに配送保証商品が含まれていることを確認します。",
  "TestNow": "今すぐテスト",
  "Working": "問題なく動作中",
  "NeedHelp": "ヘルプが必要ですか",
  "MarkAsCompleted": "完了としてマーク",
  "AppStatus": "アプリのステータス",
  "AppEmbed": "アプリ埋め込み",
  "EnableAppEmbedToDisp": "アプリ埋め込みを有効にして、カートに配送保証を表示します。",
  "CartPage": "カートページに配送保証を表示します。",
  "CheckoutBlock": "チェックアウトブロック",
  "CheckoutPage": "チェックアウトページに配送保証を表示します。",
  "Active": "有効",
  "Inactive": "無効",
  "Analytics": "分析",
  "Today": "今日",
  "Last7Days": "過去 7 日間",
  "Last30Days": "過去 30 日間",
  "Last60Days": "過去 60 日間",
  "Last90Days": "過去 90 日間",
  "Last365Days": "過去 365 日間",
  "Custom": "カスタム",
  "Start": "開始",
  "End": "終了",
  "DateRange": "期間",
  "SelectedRange": "選択した期間: {{range}}",
  "Cancel": "キャンセル",
  "Save": "保存",
  "ChooseAStartDateOnOr": "終了日以前の開始日を選択してください。今日より後の日付は選択できません。",
  "PreviousMonth": "前月",
  "NextMonth": "翌月",
  "ProtectionRevenue": "保証売上",
  "ProtectedOrders": "保証対象注文",
  "ProtectedOrderRate": "注文保証率",
  "LoadingAnalytics": "分析を読み込み中…",
  "AnalyticsCouldNotLo": "分析を読み込めませんでした",
  "RetryAnalytics": "分析を再試行",
  "Resources": "リソース",
  "HowDoesShippingProte": "配送保証の仕組み",
  "BlyCareAddsAShipping": "BlyCare はカートに配送保証ウィジェットを追加します。顧客は注文に保証を追加するか選択できます。販売者が保証料金を徴収し、補償対象となる状況を決定し、その料金を使って請求を処理します。",
  "DoesBlyCareCoverInsu": "BlyCare は保険金請求を補償しますか？",
  "NoBlyCareIsNotInsura": "いいえ。BlyCare は保険ではなく、請求の支払いも行いません。BlyCare は販売者が独自の配送保証プログラムを管理するためのウィジェットとツールのみを提供します。",
  "EmailUs": "メールでお問い合わせ",
  "LiveChat": "ライブチャット",
  "HelpCenter": "ヘルプセンター",
  "Settings": "設定",
  "CheckoutWidget": "チェックアウトウィジェット",
  "CartWidget": "カートウィジェット",
  "PriceSetting": "価格設定",
  "ProductSetting": "商品設定",
  "AdminLanguage": "管理画面の言語",
  "AdminLanguageTitle": "管理画面の言語",
  "AdminLanguageHelp": "ご自身のアプリ言語のみを変更します。顧客には影響しません。",
  "AppLanguage": "アプリの言語",
  "UnableToLoadSettings": "設定を読み込めません",
  "TryAgain": "再試行",
  "Discard": "破棄",
  "LoadingSettings": "設定を読み込み中",
  "PageNotFound": "ページが見つかりません",
  "ProductSettingsCould": "商品設定を保存できませんでした。",
  "Fulfillment": "フルフィルメント",
  "FulfillmentHelp": "保証商品をいつフルフィルメント済みにするかを選択します。",
  "ManuallyFulfill": "手動でフルフィルメント",
  "MarkFulfilledWhenFir": "注文の最初の商品がフルフィルメントされたときに済みにする",
  "MarkFulfilledWhenAll": "注文の他のすべての商品がフルフィルメントされたときに済みにする",
  "MarkFulfilledImmedi": "注文作成後すぐに済みにする",
  "Exclusions": "除外",
  "ExclusionsHelp": "保証を適用しない条件を選択します。",
  "ExclusionType": "除外タイプ",
  "Select": "選択",
  "SelectedExclusions": "選択した除外",
  "RemoveName": "{{name}} を削除",
  "WhenExcluded": "除外時",
  "HideWidget": "ウィジェットを非表示",
  "KeepWidgetButSkipThe": "ウィジェットを表示して料金をスキップ",
  "ExcludeProductType": "商品タイプを除外",
  "SearchProductType": "商品タイプを検索",
  "ExcludeSKU": "SKU を除外",
  "SearchSKU": "SKU を検索",
  "ExcludeCollection": "コレクションを除外",
  "SearchCollection": "コレクションを検索",
  "ExcludeMarket": "マーケットを除外",
  "SearchMarket": "マーケットを検索",
  "ExcludeLanguage": "言語を除外",
  "SearchLanguage": "言語を検索",
  "Add": "追加",
  "PriceSettingsCouldNo": "価格設定を保存できませんでした。",
  "ShippingProtectionPr": "配送保証の価格",
  "SetHowMuchPriceDoYou": "顧客に請求する金額を設定します",
  "PricingMethod": "価格設定方法",
  "Fixed": "固定",
  "Percentage": "パーセンテージ",
  "UniversalProtectionP": "共通保証価格",
  "PercentageOfCartSubt": "カート小計の割合",
  "EditCappedPrice": "上限価格を編集",
  "ShippingProtectionFe": "配送保証料金（割合ベース）：{{minPrice}} USD から開始し、{{increment}} USD ずつ増加、上限は {{capped}} USD です。",
  "MinProtectionFee": "最低保証料金",
  "IncrementAmount": "増加額",
  "CappedProtectionFee": "上限保証料金",
  "AddTierPrice": "段階価格を追加",
  "AddTier": "段階を追加",
  "TierPriceHelp": "カート価格がどの段階のカート価格範囲にも一致しない場合、前のページで設定した共通価格が適用されます。",
  "MinCartPrice": "最低カート金額",
  "MaxCartPrice": "最高カート金額",
  "ProtectionFee": "保証料金",
  "RemoveTier": "段階を削除",
  "Required": "必須",
  "ThisFieldIsRequired": "この項目は必須です。",
  "MustBeGreaterThanZero": "{{label}} は 0 より大きい必要があります。",
  "MustBeOrLess": "{{label}} は {{max}} 以下である必要があります。",
  "AtMostTwoDecimals": "{{label}} は小数点以下 2 桁までです。",
  "MustBeLargerThanMinC": "最低カート金額より大きくする必要があります",
  "MustBeLargerThanMaxC": "最高カート金額より大きくする必要があります",
  "MustBeSmallerThanMin": "最低カート金額より小さくする必要があります",
  "Price": "価格",
  "MinimumPrice": "最低価格",
  "Increment": "増加額",
  "CartPageWidget": "カートページウィジェット",
  "CheckoutPageWidget": "チェックアウトページウィジェット",
  "WidgetFormat": "ウィジェット形式",
  "TickerWidget": "標準ウィジェット",
  "CheckoutButtonWidget": "チェックアウトボタンウィジェット",
  "Text": "テキスト",
  "MainText": "メインテキスト",
  "Title": "タイトル",
  "Description": "説明",
  "MainButtonText": "メインボタンのテキスト",
  "SecondaryButtonText": "セカンダリボタンのテキスト",
  "EnabledDescription": "有効時の説明",
  "DisabledDescription": "無効時の説明",
  "PleaseEnterTitle": "タイトルを入力してください",
  "PleaseEnterDescript": "説明を入力してください",
  "PleaseEnterMainButt": "メインボタンのテキストを入力してください",
  "PleaseEnterSecondar": "セカンダリボタンのテキストを入力してください",
  "PleaseEnterEnabledD": "有効時の説明を入力してください",
  "PleaseEnterDisabled": "無効時の説明を入力してください",
  "EGViewTerms": "例：利用規約を見る",
  "EGHttpTerms": "例：https://terms.com",
  "Footer": "フッター",
  "FooterText": "フッターテキスト",
  "FooterLink": "フッターリンク",
  "TooltipLink": "ツールチップリンク",
  "FooterVisibility": "フッターの表示",
  "TitleInfoVisibility": "タイトル情報の表示",
  "Disabled": "無効",
  "Enabled": "有効",
  "Color": "色",
  "ColorStyle": "カラースタイル",
  "SizeAndDisplay": "サイズと表示",
  "IconSize": "アイコンサイズ",
  "IconRadius": "アイコンの角丸",
  "BorderSize": "枠線の太さ",
  "BorderRadius": "枠線の角丸",
  "HorizontalPadding": "左右の余白",
  "VerticalPadding": "上下の余白",
  "ToggleFormat": "切り替え形式",
  "Switch": "スイッチ",
  "Checkbox": "チェックボックス",
  "Border": "枠線",
  "Background": "背景",
  "ProtectionDescript": "保証の説明",
  "MainButtonBackgrou": "メインボタンの背景",
  "EnabledToggle": "有効時のトグル",
  "DisabledToggle": "無効時のトグル",
  "Automatic": "自動",
  "Neutral": "ニュートラル",
  "Info": "情報",
  "Success": "成功",
  "Warning": "警告",
  "Critical": "重大",
  "Subdued": "控えめ",
  "Transparent": "透明",
  "ThemeColor": "テーマカラー",
  "ResetToDefaultColor": "{{label}}：既定の色にリセット",
  "OpenColorPicker": "{{label}}：カラーピッカーを開く",
  "Icon": "アイコン",
  "PackageIcon": "パッケージアイコン",
  "PackageIconNumber": "パッケージアイコン {{value}}",
  "UploadIcon": "アイコンをアップロード",
  "NoIcon": "アイコンなし",
  "AcceptedFormats": "対応形式：PNG、JPG、SVG",
  "MaximumFileSize": "最大ファイルサイズ：50 MB",
  "AddFiles": "ファイルを追加",
  "RemoveImage": "画像を削除",
  "Uploading": "アップロード中",
  "UploadFailedTryAgain": "アップロードに失敗しました。もう一度お試しください。",
  "ChooseAJPEGPNG": "50 MB 以下の JPEG、PNG、SVG 画像を選択してください。",
  "ChooseNonemptyImage": "50 MB 以下の空でない JPEG、JPG、PNG、SVG 画像を選択してください。",
  "ImageCouldNotBeRead": "画像を読み取れませんでした。",
  "FileContentsMismatch": "ファイルの内容は JPEG、PNG、SVG のいずれかの画像タイプと一致する必要があります。",
  "ImageCouldNotBeDecode": "画像をデコードできませんでした。",
  "InvalidImageUrl": "アップロードサービスが無効な画像 URL を返しました。",
  "MissingPublicImageUrl": "アップロードサービスが公開画像 URL を返しませんでした。",
  "CustomCssTooLong": "カスタム CSS は 2,000 文字以内である必要があります。",
  "ChooseValidIconUrl": "有効な URL のアップロード済みアイコンを選択してください。",
  "EnterNumberRange": "{{min}} から {{max}} までの数値を入力してください。",
  "EnterLocaleTextRange": "{{locale}} のテキストを 1～{{limit}} 文字で入力してください。",
  "EnterValidLearnMoreUrl": "https:// または http:// で始まる有効な「詳細を見る」URL を入力してください。",
  "ReviewHighlightedFields": "強調表示された項目を確認してください。",
  "CannotChangePublishState": "フォームが有効になるまで公開状態を変更できません：{{reason}}",
  "BlyCareCouldNotSave": "BlyCare を保存できませんでした。",
  "CheckoutRequiresPlus": "チェックアウトのカスタマイズには Shopify Plus が必要です。",
  "SaveSucceededReloadFailed": "保存リクエストは成功しましたが、最新のウィジェット設定を読み込めませんでした。変更を確認するには再読み込みしてください。",
  "BlyCareCouldNotComplete": "BlyCare はこのリクエストを完了できませんでした。",
  "ShopifyAuthorizationRequired": "Shopify の認可が必要です。",
  "AppBridgeUnavailable": "Shopify App Bridge を利用できません",
  "ExtensionStatusUnavailable": "Shopify 拡張機能のステータスを取得できません。",
  "ConfigurationPreview": "設定のプレビュー",
  "On": "オン",
  "Off": "オフ",
  "Unpublish": "公開を解除",
  "AppEmbedIsNotEnable": "アプリ埋め込みが有効になっていません。",
  "GoEnabled": "有効にする",
  "ViewOnYourStorefront": "ストアフロントで表示",
  "PreviewProtection": "保証をプレビュー",
  "MoreInformation": "詳細情報",
  "Cart": "カート",
  "Subtotal": "小計",
  "Checkout": "チェックアウト",
  "DiscountCode": "割引コード",
  "Apply": "適用",
  "Shipping": "配送料",
  "Total": "合計",
  "ShippingProtection": "配送保証",
  "Product": "商品",
  "CopyLink": "リンクをコピー"
}
